/* Promotions bar + drop-down panel (blocks/_pb-promos.liquid). */
(function () {
  if (customElements.get('hdt-pb-promos')) return;
  class HdtPbPromos extends HTMLElement {
    connectedCallback() {
      // Each child block renders its pill inside its card; collect them into the bar.
      const tags = this.querySelector('[data-pbp-tags]');
      if (tags) this.querySelectorAll('[data-pbp-pill]').forEach((pill) => tags.appendChild(pill));
      this.classList.add('is-ready');
      this.bar = this.querySelector('[data-pbp-toggle]');
      this.panel = this.querySelector('.pb-promos__panel');
      if (!this.bar || !this.panel) return;
      this._onDoc = this._onDoc.bind(this);
      this._onKey = this._onKey.bind(this);
      this.bar.addEventListener('click', () => this.toggle());
      this.bar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggle(); }
      });
      this.querySelectorAll('[data-pbp-close]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); this.close(); }));
    }
    disconnectedCallback() { this.close(); }
    get open() { return this.classList.contains('is-open'); }
    toggle() { this.open ? this.close() : this.show(); }
    show() {
      this.panel.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.bar.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._onDoc);
      document.addEventListener('keydown', this._onKey);
    }
    close() {
      if (!this.open) return;
      this.classList.remove('is-open');
      this.bar.setAttribute('aria-expanded', 'false');
      const p = this.panel;
      setTimeout(() => { if (!this.open) p.hidden = true; }, 220);
      document.removeEventListener('click', this._onDoc);
      document.removeEventListener('keydown', this._onKey);
    }
    _onDoc(e) { if (!this.contains(e.target)) this.close(); }
    _onKey(e) { if (e.key === 'Escape') { this.close(); this.bar.focus(); } }
  }
  customElements.define('hdt-pb-promos', HdtPbPromos);
})();
